import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root',
})
export class TrainerGuard implements CanActivate {
  constructor(private userService: UserService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return new Promise(async (resolve) => {
      if (!(await this.userService.isAuthenticated)) {
        this.router.navigate(['/account/login'], {
          queryParams: { next: state.url },
        });
        resolve(false);
      }

      const role = await this.userService.authUserRole;
      if (role !== 'trainer') {
        this.router.navigate(['/']);
        resolve(false);
      }

      resolve(true);
    });
  }
}
